export default __webpack_public_path__ + "assets/images/star-bc8f676f854ac2d3c55d00d6a6bfadc0.svg";